(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["framework--product-recommendations"]) return;
  try {
    
  $('#recommendations').owlCarousel({
	items: 4,
    navigation: true,
    scrollPerPage: true,
    slideSpeed: 800,
    lazyLoad: false,
    pagination: false,
    navigationText: false
  });

  } catch(e) { console.error(e); }
})();
})();
